import PropTypes from 'prop-types';

export const defaultAriaProps = {
    lang: PropTypes.string,
    'aria-label': PropTypes.string,
    'aria-labelledby': PropTypes.string,
    'aria-describedby': PropTypes.string,
    'aria-details': PropTypes.string,
    'aria-description': PropTypes.string,
    'data-testid': PropTypes.string,
    children: PropTypes.any
};

export default defaultAriaProps;
